




































import {
  AgeAgeDTO,
  AgeManagerService,
  EventManagementCreateEventItemRequest,
  EventManagementEventDTO,
  EventManagementEventEntryDTO,
  EventManagementEventService,
} from "@/common/api";
import { LANG } from "@/common/constant";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "EventTicketListComponent",
  components: {},
})
export default class EventTicketListComponent extends Vue {
  public event = null as EventManagementEventDTO;
  public ages = [] as AgeAgeDTO[];
  public eventEntries = [] as EventManagementEventEntryDTO[];
  public eventId = null as number;

  public statusCancel = {
    id: EventManagementCreateEventItemRequest.status.CANCEL,
    name: "中止",
  };

  public created() {
    this.eventId = Number(this.$router.currentRoute.params.id);

    this.getListItem();
    this.getListAge();
  }

  public mounted() {
    let base = document.createElement("link");
    base.setAttribute("rel", "stylesheet");
    base.setAttribute("href", "/css/paper.css");
    document.querySelector("head").append(base);

    base = document.createElement("link");
    base.setAttribute("rel", "stylesheet");
    base.setAttribute("href", "/css/pdf.css");
    document.querySelector("head").append(base);
  }

  public translateAttribute(attributeName) {
    const currentLang = LANG.JA;
    return this.$t(attributeName, `${currentLang}`);
  }

  public entryCount(item) {
    return this.entries(item).length;
  }

  public entries(item) {
    return this.eventEntries.filter((row) => {
      return row.event_item_id === item.id;
    });
  }

  private async getListItem() {
    const result = await EventManagementEventService.adminEventView({
      id: this.eventId,
    });
    this.event = result.data.event;
    const entries = await EventManagementEventService.adminEventEntries({
      event_id: this.eventId,
    });
    this.eventEntries = entries.data?.event_entries;
  }

  private async getListAge() {
    const result = await AgeManagerService.adminAge({});
    this.ages = result.data.ages;
  }
}
